export const ROLE_REPORT_TESTER = 'report-tester';

export const REPORT_TESTER_ROLES = [ROLE_REPORT_TESTER];
